import { IonToast } from '@ionic/react';
import React from 'react';

import { close } from 'ionicons/icons';

import type { ToastProps } from './types';

import './Toast.scss';

const Toast: React.FC<ToastProps> = ({
  isOpen,
  message,
  color = 'primary',
  duration = 5000,
  onDidDismiss,
  actionText,
  onAction,
}) => {
  return (
    <IonToast
      mode="ios"
      isOpen={isOpen}
      message={message}
      color={color}
      duration={duration}
      position="top"
      onDidDismiss={onDidDismiss}
      cssClass="custom-toast"
      buttons={[
        ...(actionText
          ? [
              {
                text: actionText,
                handler: onAction,
              },
            ]
          : []),
        {
          icon: close,
          role: 'cancel',
        },
      ]}
    />
  );
};

export default React.memo(Toast);
